var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0366 8.227L17.0489 1.1875H15.6239L10.4049 7.29956L6.23436 1.1875H1.42499L7.73061 10.431L1.42499 17.8125H2.84999L8.36236 11.3573L12.7668 17.8125H17.5762L11.0366 8.227ZM9.08555 10.5118L8.44668 9.59144L3.36299 2.26812H5.55155L9.65318 8.17831L10.2921 9.09863L15.6251 16.7817H13.4366L9.08555 10.5118Z",
    fill: "#0089E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4c88e23e916ccc9c0e5ed96ff3ab205d.svg";
export { ForwardRef as ReactComponent };